import React from 'react';
import Viewer, { defaultLayout } from '@phuocng/react-pdf-viewer';

const SimplerToolbar = ( { fileUrl, onDocumentLoad } ) => {
    const renderToolbar = ( toolbarSlot ) => {
        return (
            <div className={ "PDFViewer_commandToolbar" }
            >
                <div className={ "viewer_layout-toolbar-left" }>
                    <div style={ { padding: '0 2px' } }>
                        { toolbarSlot.toggleSidebarButton }
                    </div>
                    <div style={ { padding: '0 2px' } }>
                        { toolbarSlot.searchPopover }
                    </div>
                </div>
                <div className={ "viewer_layout-toolbar-center" }>
                    <div style={ { padding: '0 2px' } }>
                        { toolbarSlot.previousPageButton }
                    </div>
                    <div style={ { padding: '0 2px' } }>
                        { toolbarSlot.currentPage + 1 } / { toolbarSlot.numPages }
                    </div>
                    <div style={ { padding: '0 2px' } }>
                        { toolbarSlot.nextPageButton }
                    </div>
                    <div style={ { padding: '0 2px' } }>
                        { toolbarSlot.zoomOutButton }
                    </div>
                    <div style={ { padding: '0 2px' } }>
                        { toolbarSlot.zoomPopover }
                    </div>
                    <div style={ { padding: '0 2px' } }>
                        { toolbarSlot.zoomInButton }
                    </div>
                </div>
                <div className={ "viewer_layout-toolbar-right" }>
                    <div style={ { padding: '0 2px' } }>
                        { toolbarSlot.fullScreenButton }
                    </div>
                </div>
            </div>
        );
    };

    const layout = (
        isSidebarOpened,
        container,
        main,
        toolbar,
        sidebar,
    ) => {
        return defaultLayout(
            isSidebarOpened,
            container,
            main,
            toolbar( renderToolbar ),
            sidebar,
        );
    };

    return (
        <Viewer
            fileUrl={ fileUrl }
            layout={ layout }
            onDocumentLoad={ onDocumentLoad }
        />
    );
};

export default SimplerToolbar;